import React     from 'react'
import { Alert } from 'react-bootstrap'
import PropTypes from 'prop-types'

import { BadRequestError         } from 'lib/errors'
import { Panel, HorizontalForm   } from 'alto-react-components/lib/components'
import { billVerificationSetting } from 'alto-react-client-auth/lib/settings'
import { IfContactFormEnabled    } from 'alto-react-client-auth/lib/components'
import { ContactFormLink, basicRegistration, registrationWithBV, registrationWithoutBV } \
  from 'alto-react-client-auth/lib/routes'

export default class CardNumberForm extends React.Component
  @contextTypes =
    auth:     PropTypes.object
    settings: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    @state    =
      cardNumber:       ''
      errors:           null
      billVerification: billVerificationSetting(context.settings)

  render: ->
    <div>
      <Panel className="auth-panel" id="registration-panel" header="Registrace" bsStyle="info">
        {@alert()}
        {@form()}
      </Panel>

      <IfContactFormEnabled>
        {@contactInfo()}
      </IfContactFormEnabled>
    </div>

  alert: ->
    error = @state.errors?.detail

    <Alert id="card-number-alert" bsStyle="danger">{error}</Alert> if error

  contactInfo: ->
    <Alert className='contact-info'>
      Nedaří se Vám zaregistrovat? <ContactFormLink>Kontaktujte nás</ContactFormLink>.
    </Alert>

  form: ->
    error = @state.errors?.card_number

    <HorizontalForm>
      <HorizontalForm.Control id='card-number' type='text' label='Číslo karty'
       placeholder='Zadejte číslo karty'
       value={@state.cardNumber}
       valid={not error} help={error}
       onChange={(value) => @setState(cardNumber: value)}
       onKeyPress={(event) => @submit() if @isValid() and event.key == 'Enter'} />

      <HorizontalForm.Button id='submit-card-number' caption='Pokračovat' bsStyle="primary"
       onClick={@submit} disabled={!@isValid()} />
    </HorizontalForm>

  submit: =>
    @context.auth.clientByCard(@state.cardNumber)
      .then (info) =>
        switch info.found
          when 'none'
            @setState(errors: { detail: 'Klient s daným číslem karty nebyl nalezen' })
          when 'one'  then @oneClientFound(info)
          when 'many' then @manyClientsFound(info)

        null # otherwise runaway promise

      .catch BadRequestError, (error) =>
        @setState(errors: error.data)

  oneClientFound: (info) ->
    if info.registered
      @setState(errors: { detail: 'Klient je již registrován' })
    else
      if @state.billVerification.enabled
        if info.email
            @props.history.push(registrationWithoutBV,
                                card_number: @state.cardNumber, email: info.email)
        else
          if @state.billVerification.enabled
            @props.history.push(registrationWithBV,
                                card_number: @state.cardNumber, reason: 'no_valid_email')
      else
        @props.history.push(basicRegistration, card_number: @state.cardNumber)

  manyClientsFound: (info) ->
    if info.registered
      message = 'Všichni klienti s daným číslem karty jsou již registrování'
      @setState(errors: { detail: message })
    else
      if @state.billVerification.enabled
        @props.history.push(registrationWithBV,
                            card_number: @state.cardNumber, reason: 'several_clients_found')
      else
        message = 'Bylo nalezeno několik klientů s daným číslem karty'
        @setState(errors: { detail: message })

  isValid: ->
    @state.cardNumber.length
